<jdi-toast-host
	[toasts]="toastService.toasts()"
	position="top-middle"
	(toastsChange)="toastService.onToastsChange($event)"
></jdi-toast-host>

@if (showShipmentsStartupOverlay()) {
	<div
		class="fixed inset-0 z-[10000] flex items-center justify-center bg-sem-surface-subtle/95 px-6 backdrop-blur-sm"
		aria-live="polite"
		aria-busy="true"
	>
		<div class="grid place-items-center gap-5 rounded-2xl border border-sem-border-default bg-sem-surface-default/95 px-8 py-10 text-center shadow-2xl">
			<img
				src="/assets/logos/MyMidland_logo.svg"
				alt="MyMidland"
				class="block h-8 w-[196px] object-contain"
			/>

			<jdi-spinner
				variant="gradient-trail"
				tone="brand"
				[size]="80"
				ariaLabel="Loading shipments"
				i18n-ariaLabel="@@appLoadingShipmentsAriaLabel"
			></jdi-spinner>

			<p class="m-0 text-base text-sem-content-secondary" i18n="@@appLoadingShipmentsLabel">
				Loading shipments
			</p>
		</div>
	</div>
}

<router-outlet />